import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { KEY_D } from '@/constants';
import {
  checkCtrlPressed,
  checkAltPressed,
  isActiveElementEditable,
} from '@/helpers';
import { duplicateSectionContentThunk } from '@/store/actions/duplicate-section-content';

export default () => {
  const dispatch = useDispatch();

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const handleKeyDown = event => {
    if (!isActiveElementEditable()) {
      const isCtrlPressed = checkCtrlPressed(event);
      const isAltPressed = checkAltPressed(event);
      const isCombinationPressed =
        (isCtrlPressed && event.code === KEY_D) ||
        (isCtrlPressed && isAltPressed && event.code === KEY_D);

      if (isCombinationPressed) {
        event.preventDefault();
        dispatch(duplicateSectionContentThunk());
      }
    }
  };
};
